import { render } from "./TxSubmit.vue?vue&type=template&id=309e1a6c&scoped=true"
import script from "./TxSubmit.vue?vue&type=script&lang=js"
export * from "./TxSubmit.vue?vue&type=script&lang=js"

import "./TxSubmit.vue?vue&type=style&index=0&id=309e1a6c&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-309e1a6c"]])

export default __exports__